import BaseAdapter from '@linc-technologies/linced-common/adapters/base';

export default class Application extends BaseAdapter {}
